import { compose, createStore, applyMiddleware } from 'redux';
import createBrowserHistory from 'history/createBrowserHistory';
import { persistStore, persistReducer } from 'redux-persist';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import mixpanelMiddleware from '../middleware/mixpanelMiddleware';
import storage from 'redux-persist/lib/storage';
import { responsiveStoreEnhancer } from 'redux-responsive';

const persistConfig = {
  key: 'persistor',
  storage,
  whitelist: ['map', 'settings', 'auth'],
};

const history = createBrowserHistory();
const persistedReducer = persistReducer(persistConfig, rootReducer(history));

let composeEnhancers = compose;
if (
  process.env.NODE_ENV !== 'production' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}

const reactRouteMiddleware = routerMiddleware(history);

let middlewares = [reactRouteMiddleware, thunk];

// if (!process.env.REACT_APP_DISABLE_MIXPANEL) {
middlewares.push(mixpanelMiddleware);
// }

if (
  process.env.NODE_ENV !== 'production' &&
  process.env.NODE_ENV !== 'test' &&
  process.env.REACT_APP_DISABLE_LOGGERS === 'false'
) {
  const { logger } = require('redux-logger');
  middlewares = [...middlewares, logger];
}

const store = createStore(
  persistedReducer,
  composeEnhancers(responsiveStoreEnhancer, applyMiddleware(...middlewares))
);
const persistor = persistStore(store);
export { store, history, persistor };



// WEBPACK FOOTER //
// ./src/store/index.js